<template>
  <div class="mainDiv">

      <div class="nav">
            <v-chart ref="chart_nav" class="chart_nav" :option="option_nav" />
      </div>

      <div class="graph1" @click="closeAllPop">
        <!--<img src="@/assets/images2/bg.png">-->




        <div class="btn btn1" @click.stop="btn1_click"></div>
        <div class="btn btn2" @click.stop="btn2_click"></div>
        <div class="btn btn3" @click.stop="btn3_click"></div>
        <div class="btn btn4" @click.stop="btn4_click"></div>
        <div class="btn btn5" @click.stop="btn5_click"></div>
        <div class="btn btn6" @click.stop="btn6_click"></div>





        <div class="pop pop1" :class="{hideMode: !pop1_isshow}" @click.stop="fun_null">
            <v-chart ref="chart1" class="chart"/>
        </div>

        <div class="pop pop2" :class="{hideMode: !pop2_isshow}" @click.stop="fun_null">
            <v-chart ref="chart2" class="chart"/>
        </div>

        <div class="pop pop3" :class="{hideMode: !pop3_isshow}" @click.stop="fun_null">
            <v-chart ref="chart3" class="chart"/>
        </div>

        <div class="pop pop4" :class="{hideMode: !pop4_isshow}" @click.stop="fun_null">
            <v-chart ref="chart4" class="chart"/>
        </div>

        <div class="pop pop5" :class="{hideMode: !pop5_isshow}" @click.stop="fun_null">
            <v-chart ref="chart5" class="chart"/>
        </div>

        <div class="pop pop6" :class="{hideMode: !pop6_isshow}" @click.stop="fun_null">
            <v-chart ref="chart6" class="chart"/>
        </div>

      </div>
  </div>
</template>

<script>
export default {
  name: 'graph1',
  props: {
    avadata: Object,
    simpleavadata: Object,
    showDemo: String
  },
  data() {
    return {
      option_nav:{},
      owndata: {},

      pop1_isshow : false,
      pop2_isshow : false,
      pop3_isshow : false,
      pop4_isshow : false,
      pop5_isshow : false,
      pop6_isshow : false,


      days : [ '' ],
      hours: [ 'aaa', 'bbb', 'ccc', 'ddd', 'eee'],
        // [days, hours, value]。  days只有1个, 所以都是[0, x, y]
        // 个人/机构/国家
      //data1 : [[0, '欧盟', 0.97], [0, '美国', 0.84], [0, '英国', 0.62], [0, '中国', 0.6], [0, '德国', 0.59]],
      data1 : [[0, '中国', 0.6], [0, '欧盟', 0.97], [0, '德国', 0.59], [0, '英国', 0.62], [0, '美国', 0.84], [0, '英国', 0.62]],
        // 出版
      data2 : [[0, '中国', 878341], [0, '欧盟', 922546], [0, '德国', 208215], [0, '英国', 246298], [0, '美国', 745515] ],
        // 期刊
      data3 : [[0, '中国', 224459], [0, '欧盟', 383738], [0, '德国', 91725], [0, '英国', 100047], [0, '美国', 191885] ],
        // 资源开放共享
      data4 : [[0, '中国', 696607.9], [0, '欧盟', 997823.6], [0, '德国', 231384.3], [0, '英国', 297993.4], [0, '美国', 1009915] ],
        // 数据平台仓库
      data5 : [[0, '中国', 788857.4], [0, '欧盟', 1136711], [0, '德国', 1143142], [0, '英国', 1130286], [0, '美国', 1131800] ],
        // 学术交流
      data6 : [[0, '中国', 189549], [0, '欧盟', 405295], [0, '德国', 110084], [0, '英国', 148755], [0, '美国', 280223] ],


      base_option : {
          legend    : { show: false, }, polar     : {},
          angleAxis : {
            type        : 'category',
            splitLine   : { show: false },
            axisTick    : { show: false },
            axisLabel   : { show: false },
            axisLine    : { show: false },
          },
          radiusAxis: { 
            data: [], 
            axisLine: { show: false },
          },

            // https://echarts.apache.org/zh/option.html#series-scatter
          series: [
            {
              itemStyle:{ borderColor: '#fff', color: '#FFC000', opacity : 1 },
              type: 'scatter',
              coordinateSystem: 'polar',
              label: {
                show: true,
                color: '#fff',
                    /* 字符串模板 模板变量有：
                        {a}：系列名。
                        {b}：数据名。
                        {c}：数据值。
                        {@xxx}：数据中名为 'xxx' 的维度的值，如 {@product} 表示名为 'product' 的维度的值。
                        {@[n]}：数据中维度 n 的值，如 {@[3]} 表示维度 3 的值，从 0 开始计数。
                    */
                formatter: '{@[1]}\n{@[2]}',
              },

              symbol: 'circle',
              animationDelay: function (idx) { return idx * 5; },

              // 如下2个, 是要设置的
              symbolSize: function (val) {
                return val[2] * 70;
              },
              //data: [],
              data: [23,  44,  55,  19],
            }
          ]
      },


    }
  },
  watch: {
    treemapdata: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    console.log('[stackChart/mounted]')
    this.$nextTick(() => {
      if (this.showDemo == 'true') {
        this.owndata = this.avadata
        this.getDataView()
      } else {
        this.owndata = this.simpleavadata
        setTimeout(() => {
          this.getDataView()
        }, 2000)
      }
    })
  },
  methods: {
    init_nav(){
      this.option_nav = {
          legend: { data: ['China', 'EU27', 'Germany', 'India', 'Japan', 'Russia', 'STLCs', 'UK', 'USA'] },

          grid: { show:true, height:0, width:0, containLabel: false },
          xAxis: { show:false, type: 'category', boundaryGap: false, data: [] },
          yAxis: { show:false, type: 'value' },
          series: [
            { name: 'STLCs', type: 'line', stack: 'Total',},
            { name: 'China', type: 'line', stack: 'Total',},
            { name: 'EU27', type: 'line', stack: 'Total',},
            { name: 'Germany', type: 'line', stack: 'Total',},
            { name: 'India', type: 'line', stack: 'Total',},
            { name: 'Japan', type: 'line', stack: 'Total',},
            { name: 'Russia', type: 'line', stack: 'Total',},
            { name: 'UK', type: 'line', stack: 'Total',},
            { name: 'USA', type: 'line', stack: 'Total',},
          ]
      }
      this.$refs['chart_nav'].setOption(this.option_nav);
    },
    getDataView() {
      console.log('[stackChart/getDataView]');
      this.init_nav();

      let that=this;

      // 第1个图, '个人/机构/国家'
      let option1 = Object.assign({}, that.base_option);
      option1.series[0].symbolSize = function (val) {
                return val[2] * 70;
      };
      option1.series[0].data = that.data1;
      this.$refs['chart1'].setOption(option1);

      // 第2个图, '出版'
      let option2 = Object.assign({}, that.base_option);
      option2.series[0].symbolSize = function (val) {
                //return Math.sqrt(val[2] / 200);
                return Math.sqrt(Math.sqrt(val[2] *10));
      };
      option2.series[0].data = that.data2;
      this.$refs['chart2'].setOption(option2);

      // 第3个图, '期刊'
      let option3 = Object.assign({}, that.base_option);
      option3.series[0].symbolSize = function (val) {
                return Math.sqrt(Math.sqrt(val[2] *30));
      };
      option3.series[0].data = that.data3;
      this.$refs['chart3'].setOption(option3);

      // 第4个图, '资源开放共享'
      let option4 = Object.assign({}, that.base_option);
      option4.series[0].symbolSize = function (val) {
                return Math.sqrt(Math.sqrt(val[2] *30));
      };
      option4.series[0].data = that.data4;
      this.$refs['chart4'].setOption(option4);

      // 第5个图, '数据平台仓库'
      let option5 = Object.assign({}, that.base_option);
      option5.series[0].symbolSize = function (val) {
                return Math.sqrt(Math.sqrt(val[2] *8));
      };
      option5.series[0].data = that.data5;
      this.$refs['chart5'].setOption(option5);

      // 第6个图, '学术交流'
      let option6 = Object.assign({}, that.base_option);
      option6.series[0].symbolSize = function (val) {
                return Math.sqrt(Math.sqrt(val[2] *40));
      };
      option6.series[0].data = that.data6;
      this.$refs['chart6'].setOption(option6);

    },
    resize() {
      this.$refs['chart_nav'].resize()
      this.$refs['chart1'].resize()
      this.$refs['chart2'].resize()
      this.$refs['chart3'].resize()
      this.$refs['chart4'].resize()
      this.$refs['chart5'].resize()
      this.$refs['chart6'].resize()
    },

    // 关闭所有气泡
    closeAllPop(){
        this.pop1_isshow = false;
        this.pop2_isshow = false;
        this.pop3_isshow = false;
        this.pop4_isshow = false;
        this.pop5_isshow = false;
        this.pop6_isshow = false;
    },
    fun_null(){
    },

    btn1_click(){
        this.closeAllPop();
        this.pop1_isshow = true;
    },
    btn2_click(){
        this.closeAllPop();
        this.pop2_isshow = true;
    },
    btn3_click(){
        this.closeAllPop();
        this.pop3_isshow = true;
    },
    btn4_click(){
        this.closeAllPop();
        this.pop4_isshow = true;
    },
    btn5_click(){
        this.closeAllPop();
        this.pop5_isshow = true;
    },
    btn6_click(){
        this.closeAllPop();
        this.pop6_isshow = true;
    },
  }
}
</script>

<style>
.nav{ height:20px; padding-top:8px; overflow:hidden; }

.graph1{
    position: relative;
    /*background:url('../assets/images2/bg.png') no-repeat; */
    background:url('../assets/images2/graph1-bg.jpg') no-repeat; 
    /*backgorund-size:cover;*/

    /*width: 900px; height:444px;*/
    background-size:900px 444px;
}
/*.graph1 img{ width: 900px; height:444px; }*/


.btn{ position:absolute; cursor:pointer; 1border:1px solid red; }

/* pop层, 用z-index控制是否显示。用v-if无法初始化, 用v-show尺寸不对。 */
.pop{ z-index:1; position:absolute;  1border:1px solid green; }
.pop.hideMode{ z-index: -1!important;}


/*
.btn1{ width: 90px; height: 55px; top: 150px;  left: 80px; }
.btn2{ width: 90px; height: 55px; top: 150px;  left: 80px; }
.btn3{ width: 90px; height: 55px; top: 150px;  left: 80px; }
.btn4{ width: 90px; height: 55px; top: 150px;  left: 80px; }
.btn5{ width: 90px; height: 55px; top: 150px;  left: 80px; }
.btn6{ width: 90px; height: 55px; top: 150px;  left: 80px; }

.graph1 .pop1{ width:200px; height:200px;  top:80px; left:20px; }
.graph1 .pop2{ width:200px; height:200px;  top:80px; left:20px; }
.graph1 .pop3{ width:200px; height:200px;  top:80px; left:20px; }
.graph1 .pop4{ width:200px; height:200px;  top:80px; left:20px; }
.graph1 .pop5{ width:200px; height:200px;  top:80px; left:20px; }
.graph1 .pop6{ width:200px; height:200px;  top:80px; left:20px; }
*/

</style>

<style>
/* 分辨率适配 */

/* 宽度大于1900。1920分辨率 */
/*@media screen and (min-width: 1900px) {*/
@media screen and (min-width: 1600px) {
        /* 1453/716 */
    .mainDiv{ width:950px; margin:0 auto; }
    .nav{ width: 950px; height:20px; }
    .graph1{ width: 950px; height:468px; background-size:950px 468px;}
    .btn1{ width: 90px; height: 55px; top: 190px;  left:  20px; }
    .btn2{ width: 90px; height: 55px; top:  86px;  left: 182px; }
    .btn3{ width: 90px; height: 68px; top:  60px;  left: 302px; }
    .btn4{ width: 90px; height: 68px; top: 300px;  left: 242px; }
    .btn5{ width: 90px; height: 68px; top: 314px;  left: 624px; }
    .btn6{ width: 90px; height: 55px; top: 278px;  left: 782px; }
    .graph1 .pop1{ width:200px; height:200px; top:120px; left:-30px;}
    .graph1 .pop2{ width:200px; height:200px; top: 10px; left:130px;}
    .graph1 .pop3{ width:200px; height:200px; top:  5px; left:246px;}
    .graph1 .pop4{ width:200px; height:200px; top:240px; left:186px;}
    .graph1 .pop5{ width:200px; height:200px; top:244px; left:570px;}
    .graph1 .pop6{ width:200px; height:200px; top:210px; left:730px;}
}

/* 宽度小于或等于1899。1366分辨率 */
@media screen and (max-width: 1599px) {
        /* 1453/716 */
    .mainDiv{ width:676px; margin:0 auto; }
    .nav{ width: 676px; height:20px; }
    .graph1{ width: 676px; height:333px; background-size:676px 333px;}
    .btn1{ width: 70px;height: 45px;top: 130px;left:  10px; }
    .btn2{ width: 70px;height: 45px;top:  60px;left: 126px; }
    .btn3{ width: 70px;height: 45px;top:  44px;left: 212px; }
    .btn4{ width: 70px;height: 45px;top: 214px;left: 170px; }
    .btn5{ width: 70px;height: 45px;top: 224px;left: 440px; }
    .btn6{ width: 70px;height: 45px;top: 194px;left: 554px; }
    .graph1 .pop1{ width:156px; height:156px; top: 80px; left:-30px;}
    .graph1 .pop2{ width:156px; height:156px; top: 10px; left: 80px;}
    .graph1 .pop3{ width:156px; height:156px; top:  0px; left:170px;}
    .graph1 .pop4{ width:156px; height:156px; top:160px; left:130px;}
    .graph1 .pop5{ width:156px; height:156px; top:170px; left:400px;}
    .graph1 .pop6{ width:156px; height:156px; top:140px; left:508px;}
}
</style>